/**
 * Unwraps the backend's single-resource response envelope.
 *
 * The API's TransformInterceptor wraps every successful response as either:
 *   - a single resource → `{ data: T }`
 *   - a paginated list  → `{ data: T[], meta: {...} }`
 *
 * This collapses the single-resource form to `T`, while leaving paginated
 * responses (which carry `meta`) intact so callers keep access to pagination.
 *
 * Single source of truth for the unwrap rule — shared by the admin axios
 * client, the mobile axios client, and @repo/api-client. If the envelope
 * shape ever changes, this is the only place to update.
 */
export function unwrapApiEnvelope<T = unknown>(body: T): T {
  if (
    body !== null &&
    typeof body === 'object' &&
    'data' in body &&
    !('meta' in body)
  ) {
    return (body as { data: T }).data
  }
  return body
}
